import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { PrescriptionItem } from 'src/app/Models/prescriptionitem.model';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-med-tracker',
  templateUrl: './med-tracker.component.html',
  styleUrls: ['./med-tracker.component.css'],
})
export class MedTrackerComponent implements OnInit {
  id = 0;
  medicationGiven: PrescriptionItem[] = [];

  constructor(
    private patientService: PatientService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });
    this.getMedicinenGiven(this.id);
  }

  getMedicinenGiven(id) {
    this.patientService.getmedicineGiven(id).subscribe((res) => {
      this.medicationGiven = res.PrescriptionItems;
    });
  }
  tabChanged(event: MatTabChangeEvent): void {
    if (event.index === 0) {
      this.getMedicinenGiven(this.id);
    }
  }
}
